var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ml-4 mr-4" },
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            },
            keydown: function($event) {
              _vm.errors.clear()
            }
          }
        },
        [
          _vm.type === "create"
            ? _c("div", { staticClass: "row py-3 align-items-center" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h1", { staticClass: "company-h1" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$router.push("/companies")
                        }
                      }
                    }),
                    _vm._v("\n          Create Company\n        ")
                  ])
                ]),
                _vm._v(" "),
                _vm.$_can("companies.update")
                  ? _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary float-right ld-ext-right",
                          class: _vm.loadingButton ? "running" : "",
                          attrs: {
                            type: "button",
                            disabled: _vm.buttonDisabled
                          },
                          on: { click: _vm.submit }
                        },
                        [
                          _vm._v("\n          CREATE COMPANY\n          "),
                          _c("div", { staticClass: "ld ld-ball ld-flip" })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.type !== "create"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "row py-3 align-items-center company-header" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("h2", { staticClass: "company-h1 mr-3" }, [
                          _c("button", {
                            staticClass: "btn btn-back",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.$router.push("/companies")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.company.name) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.company.status
                          ? [
                              _vm.company.status.name === "Active"
                                ? _c(
                                    "span",
                                    { class: "btn-status btn-active" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.company.status.name)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.company.status.name === "Inactive"
                                ? _c(
                                    "span",
                                    { class: "btn-status btn-closed" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.company.status.name)
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.company.status.name === "Setup Incomplete"
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        "btn-status btn-ncover info-company"
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.company.status.name) +
                                          "\n              "
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "btn btn-link p-0 tippy-popup tippy-info",
                                          on: {
                                            mouseover: function($event) {
                                              _vm.showTooltipStatus = true
                                            },
                                            mouseout: function($event) {
                                              _vm.showTooltipStatus = false
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-info-circle"
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showTooltipStatus
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "popover tippy-info-popover"
                                            },
                                            [
                                              _vm._v(
                                                "\n                Setup incomplete is present when the company doesn't have one or more of the following: move sizes, arrival windows, merchant account, rates and coverage.\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-8 d-flex align-items-center justify-content-end"
                      },
                      [
                        _vm.type !== "setup" &&
                        _vm.$_can("companies.review.request")
                          ? _c("companies-visibility-bar", {
                              attrs: { company: _vm.company },
                              on: {
                                saved: function($event) {
                                  _vm.$emit("saved")
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$_can("companies.update")
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary ld-ext-right ml-5",
                                class: _vm.loadingButton ? "running" : "",
                                attrs: { disabled: _vm.buttonDisabled }
                              },
                              [
                                _vm._v("\n            Save\n            "),
                                _c("div", { staticClass: "ld ld-ball ld-flip" })
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row l-m-b-16" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("h2", { staticClass: "l-header-2" }, [_vm._v("Info")]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.name,
                            expression: "company.name"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Name",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.company, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "name" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _vm.type === "setup" && _vm.carriers && !_vm.carriers.length
                      ? _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Default carrier")]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn add-button",
                              attrs: { type: "button" },
                              on: { click: _vm.openCreateCarrierModal }
                            },
                            [_vm._m(0), _vm._v("Create new\n              ")]
                          )
                        ])
                      : _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Default carrier")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.carriers,
                                placeholder: "Select Carrier",
                                disabled: !_vm.$_can("companies.update")
                              },
                              model: {
                                value: _vm.company.default_carrier_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.company,
                                    "default_carrier_id",
                                    $$v
                                  )
                                },
                                expression: "company.default_carrier_id"
                              }
                            })
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "default_carrier_id" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Email")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.email,
                            expression: "company.email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Email",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.company, "email", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "email" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Phone")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.phone,
                            expression: "company.phone"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Phone",
                          maxlength: "14",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.phone },
                        on: {
                          keydown: function($event) {
                            _vm.maskPhone($event)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.company, "phone", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "phone" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(1)
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("h2", { staticClass: "l-header-2" }, [_vm._v("Pricing")]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Min hours")]),
                        _vm._v(" "),
                        _c("flat-pickr", {
                          staticClass: "form-control",
                          attrs: {
                            config: _vm.timeConfig,
                            placeholder: "Select",
                            disabled: !_vm.$_can("companies.update"),
                            red: "flatPickr",
                            "data-input": ""
                          },
                          model: {
                            value: _vm.company.minimum_hours,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "minimum_hours", $$v)
                            },
                            expression: "company.minimum_hours"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "minimum_hours" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("Custom rate")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.booleanOptions,
                            placeholder: "Custom Rate",
                            disabled: !_vm.$_can("companies.update")
                          },
                          model: {
                            value: _vm.company.custom_rate,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "custom_rate", $$v)
                            },
                            expression: "company.custom_rate"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "custom_rate" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Deposit")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.deposit_value,
                            expression: "company.deposit_value"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Deposit",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.deposit_value },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "deposit_value",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "deposit_value" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Unit")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "simple-select" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "simple-select-header simple-select-header",
                            on: {
                              click: function($event) {
                                _vm.$_can("companies.update")
                                  ? (_vm.dropdownUnit = !_vm.dropdownUnit)
                                  : null
                              }
                            }
                          },
                          [
                            _vm.company.deposit_unit
                              ? _c("input", {
                                  staticClass: "simple-select-input",
                                  attrs: {
                                    placeholder: _vm.unitOptions.find(function(
                                      el
                                    ) {
                                      return el.id === _vm.company.deposit_unit
                                    }).name,
                                    readonly: "",
                                    disabled: !_vm.$_can("companies.update")
                                  },
                                  on: {
                                    blur: function($event) {
                                      _vm.closeList()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(2)
                          ]
                        ),
                        _vm._v(" "),
                        _vm.dropdownUnit
                          ? _c(
                              "div",
                              { staticClass: "simple-select-options" },
                              [
                                _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "select-option select-option-boolean",
                                      staticStyle: { "pointer-events": "auto" },
                                      on: {
                                        click: function($event) {
                                          _vm.setDepositUnit("$")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "select-label" },
                                        [_vm._v("$")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    {
                                      staticClass:
                                        "select-option select-option-boolean",
                                      staticStyle: { "pointer-events": "auto" },
                                      on: {
                                        click: function($event) {
                                          _vm.setDepositUnit("%")
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "select-label" },
                                        [_vm._v("%")]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "deposit_unit" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Truck price")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.truck_price,
                            expression: "company.truck_price"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Price",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.truck_price },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "truck_price",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "truck_price" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col pl-1" }, [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Drive back addition")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.driveBackAdditionOptions,
                          label: "label"
                        },
                        model: {
                          value: _vm.company.drive_back_addition,
                          callback: function($$v) {
                            _vm.$set(_vm.company, "drive_back_addition", $$v)
                          },
                          expression: "company.drive_back_addition"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(3)
            ])
          ]),
          _vm._v(" "),
          _vm.type !== "edit"
            ? _c("div", { staticClass: "row l-m-b-16" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c("h2", { staticClass: "l-header-2" }, [
                    _vm._v("Order number prefix")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Prefix")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.ref_id_prefix,
                                expression: "company.ref_id_prefix"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              autocomplete: "no",
                              maxlength: "5",
                              placeholder: "Enter Prefix"
                            },
                            domProps: { value: _vm.company.ref_id_prefix },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "ref_id_prefix",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn p-0 tippy-popup tippy-info",
                              on: {
                                mouseover: function($event) {
                                  _vm.showTooltipPrefix = true
                                },
                                mouseout: function($event) {
                                  _vm.showTooltipPrefix = false
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-info-circle" }),
                              _vm._v(" "),
                              _vm.showTooltipPrefix
                                ? _c(
                                    "div",
                                    { staticClass: "popover tippy-info-right" },
                                    [
                                      _vm._v(
                                        "\n                  Prefix will be generated automatically if you don't add it, note that once generated you won't be able\n                  to change it\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "ref_id_prefix" }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c("h2", { staticClass: "l-header-2" }, [
                    _vm._v("Rate Settings")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "col pr-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Fixed rate")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.booleanOptions,
                                placeholder: "Select"
                              },
                              model: {
                                value: _vm.company.fixed_rate,
                                callback: function($$v) {
                                  _vm.$set(_vm.company, "fixed_rate", $$v)
                                },
                                expression: "company.fixed_rate"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "fixed_rate" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col pl-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Offer duration")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.offer_duration,
                                expression: "company.offer_duration"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              autocomplete: "no",
                              placeholder: "Enter Duration"
                            },
                            domProps: { value: _vm.company.offer_duration },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "offer_duration",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "offer_duration" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col pl-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Pre-agreement sending")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.booleanOptions,
                                placeholder: "Pre-agreement sending"
                              },
                              model: {
                                value: _vm.company.customer_contract_automatic,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.company,
                                    "customer_contract_automatic",
                                    $$v
                                  )
                                },
                                expression:
                                  "company.customer_contract_automatic"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "customer_contract_automatic"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4 pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Cash discount value")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.cash_discount_value,
                                expression: "company.cash_discount_value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              autocomplete: "no",
                              placeholder: "Cash discount",
                              disabled: !_vm.$_can("companies.update")
                            },
                            domProps: {
                              value: _vm.company.cash_discount_value
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "cash_discount_value",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cash_discount_value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 pl-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Unit")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "simple-select" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "simple-select-header simple-select-header",
                                on: {
                                  click: function($event) {
                                    _vm.$_can("companies.update")
                                      ? (_vm.dropdownUnitDiscount = !_vm.dropdownUnitDiscount)
                                      : null
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  staticClass: "simple-select-input",
                                  attrs: {
                                    placeholder: _vm.company.cash_discount_unit,
                                    readonly: "",
                                    disabled: !_vm.$_can("companies.update")
                                  },
                                  on: {
                                    blur: function($event) {
                                      _vm.closeList()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(4)
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dropdownUnitDiscount
                              ? _c(
                                  "div",
                                  { staticClass: "simple-select-options" },
                                  [
                                    _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          on: {
                                            click: function($event) {
                                              _vm.setDepositUnitCash("$")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("$")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          on: {
                                            click: function($event) {
                                              _vm.setDepositUnitCash("%")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("%")]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cash_discount_unit"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 pl-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Double drive time")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.booleanOptions,
                                placeholder: "Select"
                              },
                              model: {
                                value: _vm.company.double_drive,
                                callback: function($$v) {
                                  _vm.$set(_vm.company, "double_drive", $$v)
                                },
                                expression: "company.double_drive"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "double_drive" }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("h2", { staticClass: "l-header-2" }, [_vm._v("Address")]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("State")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.states,
                            placeholder: "Select State",
                            autocomplete: "no",
                            disabled: !_vm.$_can("companies.update")
                          },
                          model: {
                            value: _vm.company.state_id,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "state_id", $$v)
                            },
                            expression: "company.state_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "state_id" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col px-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("City")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.city,
                            expression: "company.city"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter City Name",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.company, "city", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "city" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Zip")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.zip,
                            expression: "company.zip"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter ZIP",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.zip },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.company, "zip", $event.target.value)
                            },
                            function($event) {
                              _vm.getLocationFromZip(_vm.company.zip)
                            }
                          ]
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "zip" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.address,
                            expression: "company.address"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Address",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "address",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "address" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Address 2")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.address2,
                            expression: "company.address2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Apartment, Suite, Unit",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.address2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "address2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "address2" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row mb-4",
                  staticStyle: { position: "relative" }
                },
                [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h2", { staticClass: "l-header-2" }, [
                      _vm._v("\n              Time settings\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6 pr-1" }, [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Timezone")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.timezones,
                                placeholder: "Select time zone"
                              },
                              model: {
                                value: _vm.company.timezone,
                                callback: function($$v) {
                                  _vm.$set(_vm.company, "timezone", $$v)
                                },
                                expression: "company.timezone"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showTooltipTimezone
                          ? _c("span", { staticClass: "timezone-tooltip" }, [
                              _vm._v(
                                "\n                  We set your timezone to match your location, if you'd like to change it, use this field.\n                "
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 pl-1" }, [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Time increment")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.timeIncrementOptions,
                                label: "label"
                              },
                              model: {
                                value: _vm.company.minute_increment,
                                callback: function($$v) {
                                  _vm.$set(_vm.company, "minute_increment", $$v)
                                },
                                expression: "company.minute_increment"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "info-tooltip",
                          on: {
                            mouseover: function($event) {
                              _vm.tooltip = true
                            },
                            mouseleave: function($event) {
                              _vm.tooltip = false
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-info-circle pr-2" }),
                          _vm._v(" "),
                          _vm.tooltip
                            ? _c(
                                "div",
                                { staticClass: "popover tippy-info-up" },
                                [
                                  _vm._v(
                                    "\n                  Selected time increment will round up your total job time and allow you to select minute increments on the job.\n                  If you choose option for 10 minutes and your job took 04:53 it will round up to 04:50.\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("h2", { staticClass: "l-header-2" }, [
                _vm._v("Parking Address")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col pr-3 pr-md-1 pr-lg-1 pr-xl-1 mb-2 mb-lg-0 mb-md-0 mb-xl-0"
                  },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Search parking address")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.parking_full_address,
                            expression: "company.parking_full_address"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.company.parking_full_address },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.company,
                                "parking_full_address",
                                $event.target.value
                              )
                            },
                            function($event) {
                              _vm.getAddressData(
                                _vm.company.parking_full_address
                              )
                            }
                          ],
                          keydown: function($event) {
                            if (
                              !("button" in $event) &&
                              _vm._k($event.keyCode, "down", 40, $event.key, [
                                "Down",
                                "ArrowDown"
                              ])
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            $event.target.nextElementSibling &&
                              $event.target.nextElementSibling.firstChild.focus()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showDropdown === true && _vm.addresses
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu show address-field-wrap",
                              attrs: { "aria-labelledby": "dropdownMenu2" }
                            },
                            _vm._l(_vm.addresses, function(
                              addressItem,
                              indexAddr
                            ) {
                              return _c(
                                "button",
                                {
                                  key: "btn-prefix-" + indexAddr,
                                  staticClass: "dropdown-item",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.setAddress(addressItem)
                                    },
                                    keydown: [
                                      function($event) {
                                        if (
                                          !("button" in $event) &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        _vm.setAddress(addressItem)
                                      },
                                      function($event) {
                                        if (
                                          !("button" in $event) &&
                                          _vm._k(
                                            $event.keyCode,
                                            "down",
                                            40,
                                            $event.key,
                                            ["Down", "ArrowDown"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        $event.target.nextElementSibling.focus()
                                      },
                                      function($event) {
                                        if (
                                          !("button" in $event) &&
                                          _vm._k(
                                            $event.keyCode,
                                            "up",
                                            38,
                                            $event.key,
                                            ["Up", "ArrowUp"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.target.previousElementSibling.focus()
                                      }
                                    ]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(addressItem.full_address) +
                                      "\n                "
                                  )
                                ]
                              )
                            })
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "select-wrap" },
                      [
                        _c("label", [_vm._v("State")]),
                        _vm._v(" "),
                        _c("simple-select", {
                          attrs: {
                            options: _vm.states,
                            placeholder: "Select State",
                            autocomplete: "no",
                            disabled: !_vm.$_can("companies.update")
                          },
                          model: {
                            value: _vm.company.parking_state_id,
                            callback: function($$v) {
                              _vm.$set(_vm.company, "parking_state_id", $$v)
                            },
                            expression: "company.parking_state_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "parking_state_id" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col px-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("City")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.parking_city,
                            expression: "company.parking_city"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter City Name",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.parking_city },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "parking_city",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "parking_city" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Zip")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.parking_zip,
                            expression: "company.parking_zip"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter ZIP",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.parking_zip },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "parking_zip",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "parking_zip" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col pr-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Address")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.parking_address,
                            expression: "company.parking_address"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Enter Address",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.parking_address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "parking_address",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "parking_address" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col pl-1" },
                  [
                    _c("div", { staticClass: "select-wrap" }, [
                      _c("label", [_vm._v("Address 2")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.company.parking_address2,
                            expression: "company.parking_address2"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          autocomplete: "no",
                          placeholder: "Apartment, Suite, Unit",
                          disabled: !_vm.$_can("companies.update")
                        },
                        domProps: { value: _vm.company.parking_address2 },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.company,
                              "parking_address2",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "parking_address2" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm._m(6)
            ]),
            _vm._v(" "),
            _vm.type === "edit"
              ? _c("div", { staticClass: "col-6" }, [
                  _c("h2", { staticClass: "l-header-2" }, [
                    _vm._v("Rate Settings")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "col pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Fixed rate")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "simple-select" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "simple-select-header simple-select-header",
                                on: {
                                  click: function($event) {
                                    _vm.$_can("companies.update")
                                      ? (_vm.dropdown = true)
                                      : null
                                  }
                                }
                              },
                              [
                                _vm.company.fixed_rate
                                  ? _c("input", {
                                      staticClass: "simple-select-input",
                                      attrs: {
                                        placeholder: _vm.booleanOptions.find(
                                          function(el) {
                                            return (
                                              el.id === _vm.company.fixed_rate
                                            )
                                          }
                                        ).name,
                                        disabled: !_vm.$_can("companies.update")
                                      },
                                      on: {
                                        blur: function($event) {
                                          _vm.closeList()
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._m(7)
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dropdown
                              ? _c(
                                  "div",
                                  { staticClass: "simple-select-options" },
                                  [
                                    _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          staticStyle: {
                                            "pointer-events": "auto"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.setRate(1)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("Yes")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          staticStyle: {
                                            "pointer-events": "auto"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.setRate(0)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("No")]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "fixed_rate" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col pl-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Offer duration")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.offer_duration,
                                expression: "company.offer_duration"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              autocomplete: "no",
                              placeholder: "Enter Duration"
                            },
                            domProps: { value: _vm.company.offer_duration },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "offer_duration",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "offer_duration" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col pl-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Pre-agreement sending")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.booleanOptions,
                                placeholder: "Pre-agreement sending"
                              },
                              model: {
                                value: _vm.company.customer_contract_automatic,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.company,
                                    "customer_contract_automatic",
                                    $$v
                                  )
                                },
                                expression:
                                  "company.customer_contract_automatic"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "customer_contract_automatic"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-4 pr-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Cash discount value")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.company.cash_discount_value,
                                expression: "company.cash_discount_value"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              autocomplete: "no",
                              placeholder: "Cash discount",
                              disabled: !_vm.$_can("companies.update")
                            },
                            domProps: {
                              value: _vm.company.cash_discount_value
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.company,
                                  "cash_discount_value",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cash_discount_value"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 pl-1" },
                      [
                        _c("div", { staticClass: "select-wrap" }, [
                          _c("label", [_vm._v("Unit")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "simple-select" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "simple-select-header simple-select-header",
                                on: {
                                  click: function($event) {
                                    _vm.$_can("companies.update")
                                      ? (_vm.dropdownUnitDiscount = !_vm.dropdownUnitDiscount)
                                      : null
                                  }
                                }
                              },
                              [
                                _c("input", {
                                  staticClass: "simple-select-input",
                                  attrs: {
                                    placeholder: _vm.company.cash_discount_unit,
                                    readonly: "",
                                    disabled: !_vm.$_can("companies.update")
                                  },
                                  on: {
                                    blur: function($event) {
                                      _vm.closeList()
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(8)
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dropdownUnitDiscount
                              ? _c(
                                  "div",
                                  { staticClass: "simple-select-options" },
                                  [
                                    _c("ul", [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          on: {
                                            click: function($event) {
                                              _vm.setDepositUnitCash("$")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("$")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "select-option select-option-boolean",
                                          on: {
                                            click: function($event) {
                                              _vm.setDepositUnitCash("%")
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "select-label" },
                                            [_vm._v("%")]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cash_discount_unit"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-4 pl-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Double drive time")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: {
                                options: _vm.booleanOptions,
                                placeholder: "Select"
                              },
                              model: {
                                value: _vm.company.double_drive,
                                callback: function($$v) {
                                  _vm.$set(_vm.company, "double_drive", $$v)
                                },
                                expression: "company.double_drive"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "double_drive" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(9),
                  _vm._v(" "),
                  _c("h2", { staticClass: "l-header-2" }, [
                    _vm._v("Cluster fee")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mb-3" }, [
                    _c(
                      "div",
                      { staticClass: "col pr-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap amount-wrap-small" },
                          [
                            _c("label", [_vm._v("Cluster fee")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dollar mt-3 pt-1" }, [
                              _vm._v("$")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.cluster_fee,
                                  expression: "company.cluster_fee"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                autocomplete: "no",
                                placeholder: "Enter Cluster fee"
                              },
                              domProps: { value: _vm.company.cluster_fee },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.company,
                                    "cluster_fee",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "cluster_fee" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col pl-1" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap amount-wrap-small" },
                          [
                            _c("label", [_vm._v("Cluster percent")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "dollar mt-3 pt-1" }, [
                              _vm._v("%")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.company.cluster_percent,
                                  expression: "company.cluster_percent"
                                }
                              ],
                              staticClass: "form-control pl-4",
                              attrs: {
                                type: "text",
                                autocomplete: "no",
                                placeholder: "Enter Cluster percent"
                              },
                              domProps: { value: _vm.company.cluster_percent },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.company,
                                    "cluster_percent",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cluster_percent"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }),
          _vm._v(" "),
          _vm.type === "edit"
            ? _c("div", { staticClass: "row mb-4" }, [
                _c(
                  "div",
                  { staticClass: "col d-flex justify-content-end" },
                  [
                    _vm.$_can("companies.update") && _vm.company.status_id === 2
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              type: "button",
                              disabled: !_vm.$_can("companies.update")
                            },
                            on: {
                              click: function($event) {
                                _vm.setCompanyStatus(1)
                              }
                            }
                          },
                          [_vm._v("\n          Activate\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("companies.update") && _vm.company.status_id === 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-delete",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                _vm.setCompanyStatus(2)
                              }
                            }
                          },
                          [_vm._v("\n          Deactivate\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("error-field", {
                      attrs: { errors: _vm.errors, field: "status_id" }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showCreateCarrierModal
        ? _c(
            "modal",
            {
              attrs: { size: "modal-medium" },
              on: {
                close: function($event) {
                  _vm.showCreateCarrierModal = false
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Create Carrier")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("div", { staticClass: "select-wrap mb-2" }, [
                            _c("label", { staticClass: "m-label" }, [
                              _vm._v("Name")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.carrier.name,
                                  expression: "carrier.name"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.carrier.name },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.carrier,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                  function($event) {
                                    _vm.errors.clear("carrierName")
                                  }
                                ]
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("error-field", {
                            attrs: { errors: _vm.errors, field: "carrierName" }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary ld-ext-right pull-right",
                            class: _vm.carrierLoadingButton ? "running" : "",
                            attrs: {
                              type: "button",
                              disabled: _vm.carrierFormInvalid
                            },
                            on: { click: _vm.createCarrier }
                          },
                          [
                            _vm._v("\n              Create\n              "),
                            _c("div", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      ])
                    ])
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("span", { staticClass: "mod-icon-add" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("hr", {})])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "simple-select-caret" }, [
      _c("i", { staticClass: "fa fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("hr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "simple-select-caret" }, [
      _c("i", { staticClass: "fa fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("hr", {})])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("hr")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "simple-select-caret" }, [
      _c("i", { staticClass: "fa fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "simple-select-caret" }, [
      _c("i", { staticClass: "fa fa-caret-down" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [_c("hr", {})])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-693f1775", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693f1775","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/companies/CompaniesInfo.vue
// module id = null
// module chunks = 